import { Label, DropdownMenuLabelProps } from '@radix-ui/react-dropdown-menu';

import { cn } from 'styles';
import { DropdownMenuSeparator } from './Separator';

export type DropdownTitleProps = Pick<DropdownMenuLabelProps, 'className' | 'children'> & {
  inset?: boolean;

  bottomSeparator?: boolean;
  topSeparator?: boolean;
};

export function DropdownMenuTitle({
  className,
  inset,
  bottomSeparator,
  topSeparator,
  ...props
}: DropdownTitleProps): JSX.Element {
  return (
    <>
      {topSeparator && <DropdownMenuSeparator />}

      <Label
        className={cn('px-2 py-1.5 text-sm font-semibold', inset && 'pl-8', className)}
        {...props}
      />

      {bottomSeparator && <DropdownMenuSeparator />}
    </>
  );
}
